import { Contract, ContractTenant } from '../../../../../common/validations'
import { hasActiveTermination } from '../../utils/hasActiveTermination'
import { isTerminationDisallowedBecauseOfPending } from '../../utils/isTerminationDisallowedBecauseOfPending'

export const isContractChangePending = (
  contract: Contract,
  tenants: ContractTenant[]
) =>
  hasActiveTermination(contract, tenants) ||
  isTerminationDisallowedBecauseOfPending(contract)
